/**
 * Copyright (c) 2024, Mint Metrics Pty Ltd All rights reserved. BSD 3-Clause License. https://github.com/mint-metrics/mojito/blob/master/LICENSE
 * Copyright (c) 2010, James Yu. https://github.com/jamesyu/cohorts/blob/master/LICENSE
 * Copyright (c) 2005-2017, JS Foundation All rights reserved. https://dojotoolkit.org/license.html
 * Copyright (c) 2011 Sebastian Tschan, https://blueimp.net
 */

(function () {
    function treatment() {
        const breadcrumbs = document.querySelector('nav.breadcrumb');

        const moveBreadcrumbs = function () {
            if (window.innerWidth <= 768) {
                const pageContent = document.querySelector('.page-content--product .page-width');
                if (pageContent) {
                    pageContent.insertAdjacentElement('afterbegin', breadcrumbs);
                }
            } else {
                const productMeta = document.querySelector('.product-single__meta');
                if (productMeta) {
                    productMeta.insertAdjacentElement('afterbegin', breadcrumbs);
                }
            }
        };

        if ('ontouchstart' in window) {
            window.addEventListener('resize', moveBreadcrumbs);
            moveBreadcrumbs();
        }

        const addTracks = function () {
            const links = breadcrumbs.querySelectorAll('a');
            links.forEach(link => {
                link.addEventListener('click', function () {
                    console.log('Breadcrumb clicked:', link.textContent);
                });
            });
        };

        window.setTimeout(addTracks, 0);
    }

    function trigger() {
        if (!/\/products\//gi.test(location.pathname)) {
            return;
        }

        Mojito.utils.waitForElement('nav.breadcrumb a', treatment);
    }

    trigger();
})();
